module.exports = __webpack_public_path__ + "img/role1.6f93a8f0.jpg";